/**
 * 供应商索赔枚举定义
 */

/**
 * 索赔类型
 */
export enum SupplierClaimType {
  /** 质量问题 */
  QUALITY = 1,
  /** 数量短缺 */
  SHORTAGE = 2,
  /** 交期延误 */
  DELAY = 3,
  /** 包装破损 */
  PACKAGE = 4,
  /** 其他 */
  OTHER = 5,
}

/**
 * 索赔状态
 */
export enum SupplierClaimStatus {
  /** 待处理 */
  PENDING = 0,
  /** 已确认 */
  CONFIRMED = 1,
  /** 已赔付 */
  PAID = 2,
  /** 已关闭 */
  CLOSED = 3,
  /** 已驳回 */
  REJECTED = 4,
}
